export default "__VITE_ASSET__Dpl2cG0n__"